export default "__VITE_ASSET__Y94GWb4q__"